module.exports = __webpack_public_path__ + "static/media/cockroach.5df751d7.ogg";